import Vue from 'vue'
import previousNextGroup from './components/slideshows-vue/controllers/controller-previous-next-nonoverlay.vue';

window.addEventListener("DOMContentLoaded", (e) => {
  var previousUrl = document.getElementById("previous-sov");
  if (previousUrl !== null) {
    previousUrl = previousUrl.getAttribute("data-url");
  }

  var nextUrl = document.getElementById("next-sov");
  if (nextUrl !== null) {
    nextUrl = nextUrl.getAttribute("data-url");
  }

  new Vue({
    el: document.querySelector("[data-controls-container]"),
    components: { previousNextGroup },
    template: "<previousNextGroup :previousUrl=previousUrl :nextUrl=nextUrl :gtm=gtm></previousNextGroup>",
    data: {
      previousUrl: previousUrl,
      nextUrl: nextUrl,
      gtm: "Slideshow",
    }
  });

  const image = document.querySelector("[data-overlay-image]");
  const imgSrc = image.getAttribute("data-overlay-image-src");
  image.src = imgSrc;
})
